import { RutInformation } from 'src/app/global/interfaces/rut-formatter/rut-information';

export abstract class RutFormatterService {

  abstract getRutFormats(rut: string): RutInformation;
  abstract format(rut: string): string;
  abstract getDv(run: number): string | number;
}
